import { ReactNode } from 'react';
import { ParagaphProps, Paragraph } from '../../typography';

type DrawerDescriptionProps = ParagaphProps;

export function DrawerDescription({
  children,
  ...props
}: DrawerDescriptionProps): ReactNode {
  return (
    <Paragraph
      {...props}
      marginTop="3"
      colorVariant="lighter"
      size="sm"
      weight="normal"
    >
      {children}
    </Paragraph>
  );
}
